import { makeStyles } from '@material-ui/core/styles';

const useHomeStyles = makeStyles((theme) => ({
  Home: {
    position: 'relative',
    color: '#e9f0f7',
    background:
      'radial-gradient(circle at 12% 8%, rgba(0, 212, 170, 0.18) 0, transparent 28%), radial-gradient(circle at 88% 4%, rgba(102, 126, 234, 0.16) 0, transparent 28%), radial-gradient(circle at 50% 95%, rgba(0, 212, 170, 0.10) 0, transparent 40%), linear-gradient(180deg, #06111f 0%, #0a1525 24%, #0c1728 50%, #08121f 76%, #06101c 100%)',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage:
        'linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px)',
      backgroundSize: '80px 80px',
      maskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent 90%)',
      WebkitMaskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent 90%)',
      pointerEvents: 'none',
      zIndex: 0,
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
  },
}));
export default useHomeStyles;
